<script>
  import HeaderLayout from './components/app/HeaderLayout'
  import SideNaveLayout from './components/app/SideNavLayout'
  import MessageCentreLayout from './components/app/MessageCentreLayout'
  import FooterLayout from './components/app/FooterLayout'
  
  
  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  export default {
    name: "app",
    data() {
      return {  
        // mapping:null
      }
    },
    components:{
      'header-layout':HeaderLayout,
      'sidenav-layout':SideNaveLayout,
      'message-centre-layout':MessageCentreLayout,
      'footer-layout':FooterLayout
    },
    methods: {
      ...mapActions(["setBusiness","logout","unRegister"]),

      commonactions(args){                
         switch (args.action) {
           
           case 'logout':      
              this.logout();       
             break;
           case 'unregister':      
              this.unRegister();       
             break;             
            case 'closesidebar':      
              this.closeSidebar() 
             break;
           case 'opensidebar':      
              document.getElementById("mySidebar").style.display = "block";       
             break;
          case 'openhelppage':              
             this.$refs.helpdialog.show()
             break;         
           default:
             break;
         }
      },     
      closeSidebar: () => {
        var sb = document.getElementById("mySidebar");
        if(sb)
        {
          sb.style.display = "none";
        }
      }   
    },   
    computed: {      
      ...mapGetters(["newversionavailable"])
    }
    
  };
</script>

<template>
  <div id="app">
    
    <header-layout @click="commonactions" /> 
    <sidenav-layout @click="commonactions" />
    <message-centre-layout/>
    
    <div style="margin-top:60px" @click="closeSidebar()">      
      <div @click="unRegister()" v-if="newversionavailable" class="w3-panel w3-display-container w3-green" style="z-index:900">
          <span  class="w3-button w3-large w3-display-topright w3-green" >×</span>          
          <p>Updates available, click here to quickly refresh</p>
      </div>
      <router-view class="routerview"></router-view>
    </div>     
    
    <footer-layout/>
    
    <help-dialog ref="helpdialog"/>         
      

  </div>
</template>

<style>

  .help{
    padding-top: 5px;     
    padding-right:20px;     
  }  

  @media only screen and (max-width: 600px){
    .routerview {
        /* background-color: lightblue; */
        max-width:600px;
        padding-left:10px 
    }
  }

  @media only screen and (min-width: 600px){
    .routerview {
        /* background-color: lightgreen; */
        padding-left:50px;
        max-width:900px;
    }
  }
   
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .routerview {
        /* background-color: lightcoral; */
        padding-left:75px;
        max-width:1000px;
    }
  } 

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .routerview {
        /* background-color: lightpink; */
        padding-left:100px;
        max-width:1200px;
    }
  } 


  @media only screen and (min-width: 1200px) {
    .routerview {
        /* background-color: lightsalmon; */
        padding-left:150px;
        max-width:1400px;
        
    }
  } 

</style>



// WEBPACK FOOTER //
// src/App.vue